import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";
import "../css/terms.scss";

const effectiveDate = "16 september 2026";

const sections = [
  { id: "toepassing", label: "Toepassing en demokarakter" },
  { id: "gebruik", label: "Gebruik van de website" },
  { id: "producten", label: "Producten, prijzen en voorraad" },
  { id: "bestellen", label: "Winkelmand en checkout" },
  { id: "betaling", label: "Geen echte betaling" },
  { id: "levering", label: "Levering en retour" },
  { id: "intellectueel", label: "Intellectuele eigendom" },
  { id: "aansprakelijkheid", label: "Beschikbaarheid en aansprakelijkheid" },
  { id: "privacy", label: "Privacy en lokale opslag" },
  { id: "slot", label: "Wijzigingen, recht en contact" },
];

const TermsHeading = ({ number, id, children }) => (
  <div className="legal-page__section-heading">
    <span aria-hidden="true">{String(number).padStart(2, "0")}</span>
    <h2 id={id}>{children}</h2>
  </div>
);

function Terms() {

  return (
    <main className="terms legal-page app-page-enter">
      <header className="legal-page__hero">
        <div>
          <p className="eyebrow">Juridisch / Voorwaarden</p>
          <h1>Goede afspraken,<br />eenvoudig gelezen.</h1>
        </div>
        <div className="legal-page__intro">
          <p>
            Deze voorwaarden leggen uit wat je van de frontend-demo van
            {" "}{siteConfig.displayName} mag verwachten en hoe je de website mag gebruiken.
          </p>
          <dl>
            <div>
              <dt>Van kracht</dt>
              <dd>{effectiveDate}</dd>
            </div>
            <div>
              <dt>Versie</dt>
              <dd>1.0 / Demo</dd>
            </div>
          </dl>
        </div>
      </header>

      <div className="legal-page__notice" role="note">
        <span>Demo, geen verkoop</span>
        <p>
          De winkelmand en checkout zijn uitsluitend interactief voorbeeldmateriaal. Er
          ontstaat geen koopovereenkomst, er wordt niets geleverd en er wordt nooit een
          echte betaling uitgevoerd.
        </p>
      </div>

      <div className="legal-page__layout">
        <aside className="legal-page__index">
          <nav aria-label="Inhoudsopgave gebruiksvoorwaarden">
            <p>Inhoud</p>
            <ol>
              {sections.map((section, index) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    {section.label}
                  </a>
                </li>
              ))}
            </ol>
          </nav>
        </aside>

        <article className="legal-page__body">
          <section className="legal-page__section" aria-labelledby="toepassing">
            <TermsHeading number={1} id="toepassing">
              Toepassing en demokarakter
            </TermsHeading>
            <p>
              Deze voorwaarden gelden voor ieder bezoek aan en gebruik van deze
              demonstratiewebsite. Door de site te gebruiken, aanvaard je dat alle
              winkelhandelingen simulaties zijn en geen commerciële transactie vormen.
            </p>
            <p>
              De demo is bedoeld om ontwerp, productpresentatie en een mogelijke
              ecommerceflow te tonen. Zij is geen operationele webshop en doet geen aanbod
              dat door een bezoeker kan worden aanvaard.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="gebruik">
            <TermsHeading number={2} id="gebruik">
              Gebruik van de website
            </TermsHeading>
            <p>Je mag de website bekijken en de beschikbare demofuncties normaal testen.</p>
            <p>Het is niet toegestaan om:</p>
            <ul>
              <li>de site te gebruiken voor onrechtmatige of misleidende doeleinden;</li>
              <li>beveiliging, beschikbaarheid of werking opzettelijk te verstoren;</li>
              <li>schadelijke code, geautomatiseerde aanvallen of ongewenste inhoud aan te bieden;</li>
              <li>te doen alsof een gesimuleerde order een echte bestelling of betaalbewijs is.</li>
            </ul>
          </section>

          <section className="legal-page__section" aria-labelledby="producten">
            <TermsHeading number={3} id="producten">
              Producten, prijzen en voorraad
            </TermsHeading>
            <p>
              Productnamen, omschrijvingen, afbeeldingen, materialen, kleuren, maten,
              voorraadstatussen en prijzen zijn demonstratiegegevens. Ze illustreren hoe een
              collectie kan worden gepresenteerd en zijn niet bindend.
            </p>
            <p>
              De collectiebeelden zijn illustratief; nieuw toegevoegde beelden zijn met AI gemaakt.
              Beeldschermen kunnen kleuren verschillend weergeven. Ook maat-, pasvorm- en
              onderhoudsinformatie is in deze demo informatief en geen individueel advies.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="bestellen">
            <TermsHeading number={4} id="bestellen">
              Winkelmand en checkout
            </TermsHeading>
            <p>
              Je kunt producten, varianten en aantallen aan een lokaal winkelmandje
              toevoegen. De checkout controleert velden en berekent een voorbeeldtotaal,
              maar verstuurt geen order naar {siteConfig.displayName} of een andere partij.
            </p>
            <p>
              Een bevestigingsscherm, ordernummer of statusmelding is automatisch gegenereerd
              voor de gebruikerservaring. Het is geen factuur, aankoopbewijs of
              leveringsbevestiging.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="betaling">
            <TermsHeading number={5} id="betaling">
              Geen echte betaling
            </TermsHeading>
            <p>
              De demo is niet gekoppeld aan een betaalprovider, bank, kaartnetwerk of
              kassasysteem. Er wordt geen bedrag gereserveerd of afgeschreven en ingevoerde
              kaartvelden worden niet gevalideerd bij een financiële instelling.
            </p>
            <p>
              Gebruik uitsluitend fictieve testinformatie. Voer nooit een echt kaartnummer,
              CVC, wachtwoord of andere gevoelige betaalinformatie in.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="levering">
            <TermsHeading number={6} id="levering">
              Levering en retour
            </TermsHeading>
            <p>
              Getoonde levertijden, verzendkosten, drempels voor gratis verzending en
              retourtermijnen zijn voorbeeldvoorwaarden. Omdat de demo geen bestelling
              uitvoert, ontstaat geen leverings- of retourverplichting.
            </p>
            <p>
              Bekijk de aparte pagina&apos;s over <Link to="/shipping">verzending</Link> en
              {" "}<Link to="/returns">retour</Link> voor de manier waarop deze onderdelen in
              het frontendconcept worden gepresenteerd.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="intellectueel">
            <TermsHeading number={7} id="intellectueel">
              Intellectuele eigendom
            </TermsHeading>
            <p>
              De vormgeving, teksten, software en originele beeldmiddelen van deze demo zijn
              beschermd voor zover het toepasselijke recht dat bepaalt. Gebruik voor
              persoonlijk bekijken is toegestaan; herpublicatie, verkoop of systematische
              overname vereist toestemming van de rechthebbende.
            </p>
            <p>
              Verwijzingen naar algemene technieken, materialen of plaatsen geven geen
              licentie op merken of werken van derden.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="aansprakelijkheid">
            <TermsHeading number={8} id="aansprakelijkheid">
              Beschikbaarheid en aansprakelijkheid
            </TermsHeading>
            <p>
              We streven naar een verzorgde en werkende demonstratie, maar garanderen niet
              dat de site altijd beschikbaar, foutloos of volledig is. Functionaliteit en
              inhoud kunnen zonder voorafgaande kennisgeving veranderen.
            </p>
            <p>
              Voor zover wettelijk toegestaan, zijn {siteConfig.displayName} en de makers van
              de demo niet aansprakelijk voor schade die uitsluitend voortvloeit uit het
              vertrouwen op demonstratieprijzen, voorraden, ordermeldingen of andere niet-
              operationele winkelinformatie. Wettelijke rechten die niet mogen worden
              uitgesloten, blijven onverminderd gelden.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="privacy">
            <TermsHeading number={9} id="privacy">
              Privacy en lokale opslag
            </TermsHeading>
            <p>
              Mandje en verlanglijst kunnen in de lokale opslag van je browser worden
              bewaard. Formulieren en checkoutgegevens worden niet naar een backend of
              betaalprovider verstuurd. Meer uitleg staat in onze
              {" "}<Link to="/privacy">privacyverklaring</Link>.
            </p>
          </section>

          <section className="legal-page__section" aria-labelledby="slot">
            <TermsHeading number={10} id="slot">
              Wijzigingen, recht en contact
            </TermsHeading>
            <p>
              We kunnen deze voorwaarden aanpassen wanneer de demo verandert. De nieuwste
              versie staat steeds op deze pagina. Als een bepaling niet uitvoerbaar blijkt,
              blijven de overige bepalingen zoveel mogelijk gelden.
            </p>
            <p>
              De website wordt beheerd door {siteConfig.companyName}. Deze voorwaarden
              beperken geen rechten die volgens het toepasselijke recht niet kunnen worden
              uitgesloten. Commerciële voorwaarden moeten bij een echte verkoop worden vastgesteld.
            </p>
            <address className="legal-page__contact">
              <strong>{siteConfig.companyName}</strong>
              <a href={siteConfig.website}>www.domtanion.art</a>
              <span>{siteConfig.contact.address}</span>
              <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a>
              
            </address>
          </section>
        </article>
      </div>

      <nav className="legal-page__related" aria-label="Gerelateerde informatie">
        <div>
          <p className="eyebrow">Verder lezen</p>
          <h2>Alles wat je wilt weten,<br />op één plek.</h2>
        </div>
        <div>
          <Link to="/cookies">Cookiebeleid <span aria-hidden="true">↗</span></Link>
          <Link to="/faqs">FAQs <span aria-hidden="true">↗</span></Link>
          <Link to="/privacy">Privacyverklaring <span aria-hidden="true">↗</span></Link>
          <Link to="/shipping">Verzending <span aria-hidden="true">↗</span></Link>
          <Link to="/returns">Retourbeleid <span aria-hidden="true">↗</span></Link>
          <Link to="/contact">Contact <span aria-hidden="true">↗</span></Link>
        </div>
      </nav>
    </main>
  );
}

export default Terms;
